"use client";

import dynamic from "next/dynamic";
import { useParams } from "next/navigation";
import { FC, ReactNode, createContext, useEffect, useState } from "react";

const CreateLeadModal = dynamic(() => import("@/components/CreateLeadModal/CreateLeadModal"), { ssr: false });
const CreateGenericRequestModal = dynamic(() => import("@/components/CreateGenericRequestModal/CreateGenericRequestModal"), { ssr: false });
const ContactUsModal = dynamic(() => import("@/components/ContactUsModal/ContactUsModal"), { ssr: false });
const SoftLoginModal = dynamic(() => import("@/components/SoftLogin/SoftLoginModal"), { ssr: false });

interface Props {
  settings: { [key: string]: any };
  children: ReactNode;
}
interface ModalsContextProps {
  setGetInTouchModalOpen: (open: boolean) => void;
  setGenericRequestModalOpen: (open: boolean) => void;
  setContactUsModalOpen: (open: boolean) => void;
  setEnquireModalOpen: (open: boolean) => void;
  setDownloadBrochureModalOpen: (open: boolean) => void;
  setNotifyMeModalOpen: (open: boolean) => void;
  setlocation: (location: string) => void;
  settings: { [key: string]: any };
  additionalInfo: Record<string, any>;
  setAdditionalInfo: (updated: Record<string, any>) => void;
  setMetaverseWalkthroughModalOpen: (open: boolean) => void;
}
export const ModalsContext = createContext<ModalsContextProps>({
  setGetInTouchModalOpen: () => {},
  setGenericRequestModalOpen: () => {},
  setContactUsModalOpen: () => {},
  setEnquireModalOpen: () => {},
  setDownloadBrochureModalOpen: () => {},
  setNotifyMeModalOpen: () => {},
  setlocation: () => {},
  settings: {},
  additionalInfo: {},
  setAdditionalInfo: () => {},
  setMetaverseWalkthroughModalOpen: () => {},
});

const ArticleTypeList = ["blog", "news"];

const ModalsContextProvider: FC<Props> = ({ children, settings }) => {
  const [getInTouchModalOpen, setGetInTouchModalOpen] = useState<boolean>(false);
  const [localtion, setlocation] = useState<string>("");
  const [genericRequestModalOpen, setGenericRequestModalOpen] = useState<boolean>(false);
  const [contactUsModalOpen, setContactUsModalOpen] = useState<boolean>(false);
  const [enquireModalOpen, setEnquireModalOpen] = useState<boolean>(false);
  const [downloadBrochureModalOpen, setDownloadBrochureModalOpen] = useState<boolean>(false);
  const [notifyMeModalOpen, setNotifyMeModalOpen] = useState<boolean>(false);
  const [additionalInfo, setAdditionalInfo] = useState<Record<string, any>>({});
  const [metaverseWalkthroughModalOpen, setMetaverseWalkthroughModalOpen] = useState<boolean>(false);
  const params = useParams<any>();

  let modeForEnquireModal =
    params?.slug?.[0] === "mortgage-calculator"
      ? "mortgageEnquire"
      : ArticleTypeList.includes(params?.articleType)
        ? "blogEnquireModalForTitle"
        : "enquire";

  useEffect(() => {}, [additionalInfo]);
  return (
    <ModalsContext.Provider
      value={{
        setGetInTouchModalOpen,
        setGenericRequestModalOpen,
        setContactUsModalOpen,
        setEnquireModalOpen,
        setDownloadBrochureModalOpen,
        setNotifyMeModalOpen,
        setlocation,
        settings,
        additionalInfo,
        setAdditionalInfo,
        setMetaverseWalkthroughModalOpen,
      }}
    >
      {children}
      {getInTouchModalOpen && <CreateLeadModal mode="getInTouch" closeModal={() => setGetInTouchModalOpen(false)} />}
      {genericRequestModalOpen && <CreateGenericRequestModal closeModal={() => setGenericRequestModalOpen(false)} />}
      {contactUsModalOpen && (
        <ContactUsModal
          open={contactUsModalOpen}
          closeModal={() => {
            setContactUsModalOpen(false);
            setlocation("");
          }}
          location={localtion}
        />
      )}
      {enquireModalOpen && (
        <CreateLeadModal
          mode={modeForEnquireModal}
          closeModal={() => {
            setEnquireModalOpen(false);
          }}
        />
      )}
      {downloadBrochureModalOpen && <CreateLeadModal mode="downloadBrochure" closeModal={() => setDownloadBrochureModalOpen(false)} />}
      {notifyMeModalOpen && <CreateLeadModal mode="notifyMe" closeModal={() => setNotifyMeModalOpen(false)} />}
      <SoftLoginModal />
      {/* {metaverseWalkthroughModalOpen && <CreateLeadModal mode="metaverseWalkthrough" closeModal={() => setMetaverseWalkthroughModalOpen(false)} />} */}
    </ModalsContext.Provider>
  );
};
export default ModalsContextProvider;
